import { Masonry } from '@mui/lab'
import { CircularProgress, Grid } from '@mui/material'
import { Title } from 'components'
import { getReports } from 'controllers/reports'
import { ReportDto, REPORT_SPECIAL_IDENTIFIERS } from 'dtos'
import { Navigate } from 'react-router-dom'
import { useNavigate } from 'react-router-dom'
import { useEffect, useState } from 'react'
import CustomerExportReportDialog from './CustomerExportReportDialog'
import ReportCard from './ReportCard'

export default function Reports() {
  const navigate = useNavigate()
  const [reports, setReports] = useState<ReportDto[]>([])
  const [isGettingReports, setIsGettingReports] = useState(true)
  const [isCustomerExportReportDialogOpen, setIsCustomerExportReportDialogOpen] = useState(false)

  useEffect(() => {
    getReports()
      .then(response => setReports(response.value))
      .finally(() => setIsGettingReports(false))
  }, [])

  if (isGettingReports) {
    return <CircularProgress />
  }

  if (reports.length === 0) {
    return <Navigate to='/' />
  }

  return (
    <>
      <Title>Reports</Title>

      <Grid container id='reports-page' spacing={2} alignItems='flex-start'>
        <Grid item xs={12}>
          <Masonry columns={{ xs: 1, sm: 1, md: 3, lg: 3, xl: 3 }} sequential sx={{ margin: 0 }}>
            {reports.map(report =>
              (report.specialIdentifier === REPORT_SPECIAL_IDENTIFIERS.CUSTOMER_EXPORT_REPORT ||
                report.name === 'Customer Export Report') ? (
                <ReportCard
                  key={report.reportGuid}
                  report={report}
                  onClick={() => setIsCustomerExportReportDialogOpen(true)}
                  cardId='customer-export-report-card'
                  actionId='customer-export-report-open'
                />
              ) : (
                <ReportCard
                  key={report.reportGuid}
                  report={report}
                  onClick={
                    report.specialIdentifier === REPORT_SPECIAL_IDENTIFIERS.FINANCIAL_TRANSACTIONS_ADDED_AFTER_INVOICING_REPORT
                      ? () => navigate('/reports/financial-transactions-added-after-invoicing-report')
                      : undefined
                  }
                />
              )
            )}
          </Masonry>
        </Grid>

      </Grid>

      <CustomerExportReportDialog
        open={isCustomerExportReportDialogOpen}
        onClose={() => setIsCustomerExportReportDialogOpen(false)}
      />
    </>
  )
}
